export type AssetFallback = 'procedural-hero' | 'procedural-kit'

export interface ModelPackDefinition {
  readonly id: string
  readonly url: string
  readonly colliderUrl: string
  readonly sha256: string
  readonly triangleBudget: number
  readonly preload: boolean
  readonly fallback: AssetFallback
}

export interface AssetManifest {
  readonly version: string
  readonly packs: readonly ModelPackDefinition[]
}

export const ASSET_MANIFEST: AssetManifest = {
  version: '2',
  packs: [
    {
      id: 'hero-core',
      url: '/assets/models/hero-core-v2.glb',
      colliderUrl: '/assets/colliders/hero-core-v2.json',
      sha256: '4ea5b3a8079272cda58df3f504bed06b0d259cfe4e29cc6b10240617898514c2',
      triangleBudget: 12_000,
      preload: true,
      fallback: 'procedural-hero',
    },
    {
      id: 'modular-kit',
      url: '/assets/models/modular-kit-v2.glb',
      colliderUrl: '/assets/colliders/modular-kit-v2.json',
      sha256: '529ce080ea10ccd8899a2aa21877a8edbe9fa542df71109781257afb21cd3d2d',
      triangleBudget: 120_000,
      preload: false,
      fallback: 'procedural-kit',
    },
  ],
}

export function validateAssetManifest(manifest: AssetManifest): string[] {
  const errors: string[] = []
  const ids = new Set<string>()
  for (const pack of manifest.packs) {
    if (ids.has(pack.id)) errors.push(`Duplicate asset pack id: ${pack.id}`)
    ids.add(pack.id)
    if (!/^[a-f0-9]{64}$/.test(pack.sha256)) errors.push(`${pack.id}: sha256 must be a 64-character lowercase hex digest`)
    if (!pack.url.endsWith('.glb')) errors.push(`${pack.id}: model URL must end in .glb`)
    if (!pack.colliderUrl.endsWith('.json')) errors.push(`${pack.id}: collider URL must end in .json`)
    const hardBudget = pack.id === 'hero-core' ? 20_000 : 350_000
    if (pack.triangleBudget <= 0 || pack.triangleBudget > hardBudget) {
      errors.push(`${pack.id}: triangle budget ${pack.triangleBudget} exceeds ${hardBudget}`)
    }
  }
  return errors
}
